import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { NO_KEY, YES_KEY } from '@/common/constants';
import { useFieldsWithDefaultValues } from '@/utils';

import { useMetricsStore } from '../stores';

interface Params {
  isEditMode?: boolean;
}

export default ({ isEditMode }: Params) => {
  const defaultFields = useMetricsStore((state) => state.sourceState);

  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'substantiationRate',
        type: FieldTypes.Radio,
        label: 'Substantiation Rate',
        options: [
          {
            label: 'Yes',
            value: YES_KEY,
          },
          {
            label: 'No',
            value: NO_KEY,
          },
        ],
        disabled: !isEditMode,
      },
    ],
    [isEditMode]
  );

  const formattedFields = useFieldsWithDefaultValues(fields, defaultFields);
  return formattedFields;
};
